/**
 * @generated SignedSource<<bfd5718cce49716413b703105149cb5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CalendarAddQuery$variables = Record<PropertyKey, never>;
export type CalendarAddQuery$data = {
  readonly store: {
    readonly calendarAddSuggestions: ReadonlyArray<{
      readonly iCalUrl: string;
      readonly title: string;
    }>;
  };
};
export type CalendarAddQuery = {
  response: CalendarAddQuery$data;
  variables: CalendarAddQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "CalendarSuggestion",
  "kind": "LinkedField",
  "name": "calendarAddSuggestions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iCalUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarAddQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CalendarAddQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "34d8cf6168f9cc684cbb7363ca7e3edf",
    "id": null,
    "metadata": {},
    "name": "CalendarAddQuery",
    "operationKind": "query",
    "text": "query CalendarAddQuery {\n  store {\n    calendarAddSuggestions {\n      title\n      iCalUrl\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7e214ade62f8042db7d8762310293d85";

export default node;
